import { cloneDeep, isEmpty } from 'lodash';
import nanoid from 'nanoid';

const ROW_HEIGHT = 50;

const getWidthHeight = (wdg) => {
  const type = wdg?.type ?? wdg?.widgetType;
  switch (type) {
    case 'MENTION':
    case 'LISTVIEW':
    case 'ReportWidget':
      return { width: 12, height: 6 };
    case 'REPORT_MODULE':
      return { width: 6, height: 8 };
    default:
      return { width: 6, height: 6 };
  }
};

const getDimensions = (props) => {
  const { widget, layout } = props;
  const maxY = Math.max(...layout.map((o) => o.y), 0);
  const lastRowWidgets = layout.filter((el) => el.y === maxY);
  const h = Math.max(...lastRowWidgets.map((o) => o.h), 0);
  const nextY = maxY + h;

  const { width = null, height = null } = getWidthHeight(widget);

  switch (widget?.type) {
    default:
      return {
        x: 0,
        y: nextY,
        w: width ?? 6,
        h: height ?? 8,
        i: `${nanoid()}`
      };
  }
};

const addWidget = (props) => {
  const { widget, layout } = props;
  const dimensions = getDimensions(props);
  const updatedLayout = cloneDeep(layout);
  updatedLayout.push({
    ...dimensions,
    chart: widget
  });
  return updatedLayout;
};

const reportLayoutChange = (props) => {
  const { clonedChartId, chartData = {}, clone = false, layout } = props;
  if (isEmpty(chartData)) return null;

  if (clone) {
    const updatedLayout = addWidget({
      layout: layout,
      widget: { ...chartData, type: 'REPORT_MODULE' }
    });
    return updatedLayout;
  }

  const findElement = layout?.find(
    (el) => el?.chart?.chartId === clonedChartId
  );

  const newLayout = layout.map((el) => {
    if (el.chart.chartId === clonedChartId) {
      return {
        ...el,
        x: findElement.x,
        y: findElement.y,
        h: findElement.h,
        w: findElement.w,
        chart: chartData
      };
    }
    return el;
  });

  return newLayout;
};

export { addWidget, reportLayoutChange, ROW_HEIGHT, getDimensions };
